import request from "@/utils/request.js";

/**
 * 获取验证码
 * @param {*} params 
 * @returns 
 */
export function getCap(params) {
    return request({
        url: "/api/sys/captcha",
        method: "get",
        params,
    });
}

/**
 * 用户注册
 * @param {*} data 
 * @returns 
 */
export function userRegister(data) {
    return request({
        url: "/api/user/add",
        method: "post",
        data
    })
}

/**
 * 用户登录
 * @param {*} data 
 * @returns 
 */
// export function loginByUsername(data) {
//     return request({
//         url: "/api/sys/login",
//         method: "post",
//         data
//     })
// }
export function loginByUsername(username, password,key,value) {
  const data = {
    username,
    password,
    key,
    value
  }
  return request({
    url: '/api/sys/login',
    method: 'post',
    data
  })
}

// 用户登出
export function logout() {
    return request({
      url: '/api/sys/logout',
      method: 'post',
    })
  }
//   获取用户信息
  export function getUserInfo() {
    return request({
      url: '/api/sys/info',
      method: 'post',
    })
  }